module.exports = __webpack_public_path__ + "img/bianzu21.7378ac5e.png";